
































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { CourseProgress as ICourseProgress } from "@/api/models/course-progress";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import ListenerLectureProgress from "@/components/learning-progress/ListenerLectureProgress.vue";
import ListenerTestPassProgress from "@/components/learning-progress/ListenerTestPassProgress.vue";
import ProgressDonut from "@/components/form/ProgressDonut.vue";
import { CourseListenerPass as ICourseListenerPass } from "@/api/models/course-listener-pass";
import { learningStatus } from "@/plugins/learning-status";
import { practiceStatusFormatter } from "@/plugins/statuses";
import { FormattedLectureSort } from "@/plugins/tree";
import { learningProgressPercent } from "@/plugins/learning-progress-percent";
import api from "@/getinfo-api";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { isAllowEditDates } from "@/plugins/modules-detect";
import CustomButton from "@/components/form/CustomButton.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import TextField from "@/components/form/CustomPage/textField.vue";

@Component({
  components: {
    TextField,
    CBreadCrumbs,
    CustomButton,
    CustomDatepicker,
    ListenerLectureProgress,
    ListenerTestPassProgress,
    ProgressDonut
  }
})
export default class ListenerProgressView extends Vue {
  progress!: ICourseProgress;
  listener!: ICourseListener;
  showSpinner: boolean = false;
  showEditPassedAt: boolean = false;
  passedAt!: Date | undefined;

  data() {
    return {
      progress: undefined,
      listener: undefined,
      passedAt: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "learningProgress" },
        label: `${this.$tc(this.$translate.LearnerProgress)}`
      },
      {
        label: this.$converter.limitedOutput(this.progress?.title ?? "", 40)
      }
    ];
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  // Последний сданный тест итогового теста
  get sortedPassesByPassedAt() {
    let sorted = this.progress.test?.pass;

    sorted?.sort(
      (a, b) => new Date(b.passedAt).getTime() - new Date(a.passedAt).getTime()
    );
    return sorted ? sorted[0] : undefined;
  }

  goToTestPass() {
    this.$router.push({
      name: "practicePass",
      params: {
        courseId: this.$route.params.courseId,
        listenerId: this.$route.params.listenerId
      }
    });
  }

  get canFinish() {
    return !this.progress?.passedAt;
  }

  get progressTitle() {
    return this.progress?.title ?? "";
  }

  finishLeaning(success: boolean) {
    this.showSpinner = true;
    //@ts-ignore
    let passParams: ICourseListenerPass = {
      listenerId: this.progress.listenerId,
      success: success
    };
    api.CourseApi.pass(this.$route.params.courseId, [passParams])
      .then(() => {
        this.getProgress();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  formattedStatus(status: string) {
    return learningStatus(status);
  }

  formattedPractice(status: string) {
    return practiceStatusFormatter(status);
  }

  sortedLecture() {
    if (this.progress.lectures?.length) {
      //@ts-ignore
      let allLecture = new FormattedLectureSort(this.progress.lectures);
      //@ts-ignore
      this.progress.lectures = allLecture.sortedArray;
    } else {
      this.progress.lectures = [];
    }
  }

  savePassedAt() {
    if (this.passedAt)
      api.CourseApi.listenerEditPassedAt(
        this.passedAt,
        this.progress.listener.course.id,
        this.progress.listener.id
      )
        .then(() => {
          this.getProgress();
          this.showEditPassedAt = false;
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
  }

  getProgress() {
    this.showSpinner = true;
    api.CourseApi.listenerProgress(
      this.$route.params.courseId,
      this.$route.params.listenerId
    )
      //@ts-ignore
      .then((res: { data: ICourseProgress }) => {
        this.progress = res.data;
        this.progress.test?.pass?.sort(
          (d1, d2) =>
            new Date(d2.passedAt).getTime() - new Date(d1.passedAt).getTime()
        );
        this.passedAt = this.progress.passedAt;
        this.sortedLecture();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  get percentLearning() {
    return learningProgressPercent(this.progress)
      ? learningProgressPercent(this.progress)
      : 0;
  }

  created() {
    this.getProgress();
  }
}
